export default "__VITE_ASSET__r3PDojeV__";